import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { DbSyncService } from './services/dbsync.service';
import { DeviceClockService } from './services/device-clock.service';
import { LoginLoopGuardService } from './services/login-loop-guard.service';
import { LocalizationService, AuthService, ConfigStateService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
@Component({
    selector: 'app-root',
    template: `
    <abp-loader-bar></abp-loader-bar>
    <abp-dynamic-layout></abp-dynamic-layout>
    <abp-gdpr-cookie-consent></abp-gdpr-cookie-consent>
  `,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly deviceClock = inject(DeviceClockService);
  private readonly loginLoopGuard = inject(LoginLoopGuardService);
  private readonly toaster = inject(ToasterService);
  private clockWarningShown = false;

  constructor(
    private readonly dbSyncService: DbSyncService,
    private readonly localization: LocalizationService,
    private readonly titleService: Title,
    private readonly authService: AuthService,
    private readonly config: ConfigStateService
  ) {

    console.log('Account service', this.config.getAll())

  }
  private intervalId: any;
  ngOnInit(): void {
    // The session is up, so whatever redirects happened were a normal login.
    if (this.authService.isAuthenticated) {
      this.loginLoopGuard.clear();
    }

    // DbSyncService waits for the session itself before flushing anything, so this only kicks off
    // the first pass after bootstrap (which is also the first render after a login redirect).
    this.dbSyncService.syncDb();

    //setInterval to retreive data from Unit, Area, Topic and trainingTemplate
    this.intervalId = setInterval(()=>{
      // Checked outside the auth condition: a drifting clock is worth reporting even when the
      // session did start, because every date captured offline is stamped with it.
      this.warnIfDeviceClockIsWrong();

      if (navigator.onLine && this.authService.isAuthenticated){
        this.dbSyncService.getOptions();
      }
    }, 15000)

    //Title change
  this.localization.languageChange$
  .pipe(filter(lang => !!lang)) // Filter nullish values
  .subscribe(() => {
    const newTitle = this.localization.instant('::UPMTrainingTracking'); // Translate
    this.titleService.setTitle(newTitle);
  });
  }

  ngOnDestroy(): void {
      if(this.intervalId){
        clearInterval(this.intervalId)
      }
  }

  /**
   * A device clock that drifts far enough makes the OIDC library reject freshly issued tokens as
   * expired, which reads as a server failure. Reported once per session so the user can fix the
   * actual cause.
   */
  private warnIfDeviceClockIsWrong(): void {
    if (this.clockWarningShown || !this.deviceClock.isOutOfSync()) {
      return;
    }

    this.clockWarningShown = true;
    this.toaster.warn(
      this.localization.instant('::DeviceClockWrongMessage'),
      this.localization.instant('::DeviceClockWrongTitle')
    );
  }


}
